import React from 'react';
import { useSelector } from 'react-redux';
import AboutContainer from './AboutContainer';
import SampleNftsContainer from './SampleNftsContainer';
import {
  collection,
  getDoc,
  orderBy,
  limit,
  startAfter,
  query,
  where,
  getDocs,
  writeBatch,
  doc,
} from 'firebase/firestore/lite';
import { firebaseFireStore } from '../../config/firebaseFirestore';
import ImagesContainer from './ImagesContainer';
import TeamContainer from './TeamContainer';
import { data } from 'autoprefixer';
import { httpsCallable } from 'firebase/functions';
import { firebaseFunctions } from '../../config/firebaseFunctions';

var lastDoc = null;
export default function IntroCreateComponent() {
  const bsvRate = useSelector((state) => state.bsvRateReducer.bsvRate);

  const getNftHistory = async (
    tokenId,
    isMultiple,
    nftId,
    hisId,
    hisTime,
    type,
  ) => {
    let snap;
    if (isMultiple) {
      snap = await getDocs(
        query(
          collection(firebaseFireStore, 'musicartNfts', tokenId, 'nftHistory'),
          where('nftId', '==', nftId),
        ),
      );
    } else {
      snap = await getDocs(
        collection(firebaseFireStore, 'musicartNfts', tokenId, 'nftHistory'),
      );
    }

    let purArr = [];
    snap.forEach((doc) => {
      if (
        doc.data().type &&
        doc.data().type === type &&
        doc.data().id !== hisId &&
        doc.data().timestamp < hisTime
      ) {
        purArr.push(doc.data());
      }
    });
    purArr.sort(function (a, b) {
      return Number(b.timestamp) - Number(a.timestamp);
    });

    return purArr;
  };

  // const test = async () => {
  //   console.log('start');

  //   let dataRef = await getDocs(
  //     query(collection(firebaseFireStore, 'musicartArtists')),
  //   );

  //   console.log('dataRef', dataRef._docs);
  //   let batch = writeBatch(firebaseFireStore);

  //   await Promise.all(
  //     dataRef._docs.map(async (docEle) => {
  //       let cObj = docEle.data();

  //       if (!cObj.isArtWorkNftExits) {
  //         //getting nfts
  //         let dataRef2 = await getDocs(
  //           query(
  //             collection(firebaseFireStore, 'musicartNfts'),
  //             where('artistId', '==', docEle.id),
  //             where('category', '!=', 'Music'),
  //             limit(1),
  //           ),
  //         );
  //         if (dataRef2) {
  //           let pass = false;
  //           dataRef2._docs.map(async (doc2) => {
  //             console.log('musicartist id', docEle.id);
  //             console.log('nft id', doc2.id);
  //             pass = true;
  //           });

  //           if (pass) {
  //             console.log('need to update');
  //             let NftRef = doc(firebaseFireStore, 'musicartArtists', docEle.id);
  //             batch.update(NftRef, {
  //               isArtWorkNftExits: true,
  //             });
  //           }
  //         }
  //       }
  //     }),
  //   );

  //   // await batch.commit();
  // };

  // const test = async () => {
  //   console.log('start');

  //   let dataRef = await getDocs(
  //     query(collection(firebaseFireStore, 'musicartArtists')),
  //   );

  //   console.log('dataRef', dataRef._docs);
  //   let batch = writeBatch(firebaseFireStore);

  //   await Promise.all(
  //     dataRef._docs.map(async (docEle) => {
  //       let cObj = docEle.data();

  //       if (!cObj.isMusicNftExits) {
  //         //getting nfts
  //         let dataRef2 = await getDocs(
  //           query(
  //             collection(firebaseFireStore, 'musicartNfts'),
  //             where('artistId', '==', docEle.id),
  //             where('category', '==', 'Music'),
  //             limit(1),
  //           ),
  //         );
  //         if (dataRef2) {
  //           let pass = false;
  //           dataRef2._docs.map(async (doc2) => {
  //             console.log('musicartist id', docEle.id);
  //             // console.log('nft id', doc2.id);

  //             pass = true;
  //           });

  //           if (pass) {
  //             console.log('need to update');
  //             let NftRef = doc(firebaseFireStore, 'musicartArtists', docEle.id);
  //             batch.update(NftRef, {
  //               isMusicNftExits: true,
  //             });
  //           }
  //         }
  //       }
  //     }),
  //   );

  //   await batch.commit();
  // };

  // const test = async () => {
  // console.log('start');

  // let dataRef = await getDocs(
  //   query(collection(firebaseFireStore, 'musicartNfts')),
  // );

  // let batch = writeBatch(firebaseFireStore);

  // console.log('dataRef', dataRef._docs);
  // await Promise.all(
  //   dataRef._docs.map(async (docEle) => {
  //     let cObj = docEle.data();

  //     //getting nfthistory
  //     let dataRef2 = await getDocs(
  //       query(
  //         collection(
  //           firebaseFireStore,
  //           'musicartNfts',
  //           docEle.id,
  //           'nftHistory',
  //         ),
  //         where('type', '==', 'PURCHASE'),
  //       ),
  //     );

  //     await Promise.all(
  //       dataRef2._docs.map(async (doc2) => {
  //         console.log('nft ', docEle.id);

  //         console.log('doc2 ', doc2.data());

  //         //getting seller id
  //         let hisArr = await getNftHistory(
  //           docEle.id,
  //           cObj.isMultiple,
  //           doc2.data().nftId,
  //           doc2.id,
  //           doc2.data().timestamp,
  //           'PURCHASE',
  //         );

  //         // console.log('hisArr', hisArr);
  //         let sId =
  //           hisArr && hisArr[0] && hisArr[0].userId
  //             ? hisArr[0].userId
  //             : cObj.issuerID;

  //         let saleType = sId === cObj.issuerID ? 'primary' : 'secondary';

  //         let lobj = {
  //           bsvPrice: Number(doc2.data().bidPrice),
  //           dollarPrice: Number(
  //             (Number(doc2.data().bidPrice) * bsvRate).toFixed(2),
  //           ),
  //           timestamp: doc2.data().timestamp ? doc2.data().timestamp : 0,
  //           type: 'INSTANT_BUY',
  //           orderId: doc2.id,
  //           index: doc2.data().index ? doc2.data().index : 1,
  //           txid: doc2.data() && doc2.data().txid ? doc2.data().txid : '-',
  //           nftId: docEle.id,
  //           tokenName: cObj.tokenName ? cObj.tokenName : '-',
  //           artistId: cObj.artistId ? cObj.artistId : '-',
  //           roomIds: cObj.roomIds ? cObj.roomIds : [],
  //           sellerId: sId,
  //           buyerId: doc2.data().userId,
  //           royalty: cObj.royalty,
  //           commission: 0.1,
  //           sellingPrice: Number(doc2.data().bidPrice),
  //           promoDiscount: 0,
  //           saleType: saleType,
  //         };

  //         if (cObj.isMultiple) {
  //           lobj.isMultiple = true;
  //           lobj.childId = doc2.data().nftId;
  //           lobj.nftQuantity = cObj.nftQuantity;
  //         }

  //         console.log('lobj', lobj);

  //         let NftRef = doc(firebaseFireStore, 'orderCenter', doc2.id);
  //         batch.set(NftRef, lobj);
  //       }),
  //     );
  //   }),
  // );

  // // await batch.commit();

  //   // //auction
  //   // let dataRef = await getDocs(
  //   //   query(collection(firebaseFireStore, 'musicartNfts')),
  //   // );

  //   // let batch = writeBatch(firebaseFireStore);

  //   // console.log('dataRef', dataRef._docs);
  //   // await Promise.all(
  //   //   dataRef._docs.map(async (docEle) => {
  //   //     let cObj = docEle.data();

  //   //     //getting nfthistory
  //   //     let dataRef2 = await getDocs(
  //   //       query(
  //   //         collection(
  //   //           firebaseFireStore,
  //   //           'musicartNfts',
  //   //           docEle.id,
  //   //           'nftHistory',
  //   //         ),
  //   //         where('type', '==', 'AUCTIONEND'),
  //   //       ),
  //   //     );

  //   //     await Promise.all(
  //   //       dataRef2._docs.map(async (doc2) => {
  //   //         console.log('nft ', docEle.id);

  //   //         console.log('doc2 ', doc2.data());

  //   //         //getting seller id
  //   //         let hisArr = await getNftHistory(
  //   //           docEle.id,
  //   //           cObj.isMultiple,
  //   //           doc2.data().nftId,
  //   //           doc2.id,
  //   //           doc2.data().timestamp,
  //   //           'AUCTIONEND',
  //   //         );

  //   //         // console.log('hisArr', hisArr);
  //   //         let sId =
  //   //           hisArr && hisArr[0] && hisArr[0].userId
  //   //             ? hisArr[0].userId
  //   //             : cObj.issuerID;

  //   //         let saleType = sId === cObj.issuerID ? 'primary' : 'secondary';

  //   //         let lobj = {
  //   //           bsvPrice: Number(doc2.data().bidPrice),
  //   //           dollarPrice: Number(
  //   //             (Number(doc2.data().bidPrice) * bsvRate).toFixed(2),
  //   //           ),
  //   //           timestamp: doc2.data().timestamp ? doc2.data().timestamp : 0,
  //   //           type: 'ON_AUCTION',
  //   //           orderId: doc2.id,
  //   //           index: doc2.data().index ? doc2.data().index : 1,
  //   //           txid: doc2.data() && doc2.data().txid ? doc2.data().txid : '-',
  //   //           nftId: docEle.id,
  //   //           tokenName: cObj.tokenName ? cObj.tokenName : '-',
  //   //           artistId: cObj.artistId ? cObj.artistId : '-',
  //   //           roomIds: cObj.roomIds ? cObj.roomIds : [],
  //   //           sellerId: sId,
  //   //           buyerId: doc2.data().userId,
  //   //           royalty: cObj.royalty,
  //   //           commission: 0.1,
  //   //           sellingPrice: Number(doc2.data().bidPrice),
  //   //           promoDiscount: 0,
  //   //           saleType: saleType,
  //   //         };

  //   //         if (cObj.isMultiple) {
  //   //           lobj.isMultiple = true;
  //   //           lobj.childId = doc2.data().nftId;
  //   //           lobj.nftQuantity = cObj.nftQuantity;
  //   //         }

  //   //         console.log('lobj', lobj);

  //   //         let NftRef = doc(firebaseFireStore, 'orderCenter', doc2.id);
  //   //         batch.set(NftRef, lobj);
  //   //       }),
  //   //     );
  //   //   }),
  //   // );

  //   // await batch.commit();
  // };

  // const test = async () => {
  //   console.log('start');

  //   let dataRef = await getDocs(
  //     query(collection(firebaseFireStore, 'musicartSellers')),
  //   );

  //   let batch = writeBatch(firebaseFireStore);

  //   await Promise.all(
  //     dataRef._docs.map(async (docEle) => {
  //       let cObj = docEle.data();
  //       if (cObj?.collectorAddress) {
  //         console.log(' docEle.id', docEle.id);

  //         let ObjRef = doc(firebaseFireStore, 'musicartSellers', docEle.id);
  //         batch.update(ObjRef, {
  //           collectorAddress: null,
  //         });
  //       }
  //     }),
  //   );

  //   // await batch.commit();
  //   console.log('done');
  // };

  // const test = async () => {
  //   console.log('start');

  //   let dataRef = null;

  //   if (lastDoc) {
  //     dataRef = await getDocs(
  //       query(
  //         collection(firebaseFireStore, 'musicartNfts'),
  //         startAfter(lastDoc),
  //         limit(500),
  //       ),
  //     );
  //   } else {
  //     dataRef = await getDocs(
  //       query(collection(firebaseFireStore, 'musicartNfts'), limit(500)),
  //     );
  //   }

  //   let batch = writeBatch(firebaseFireStore);
  //   console.log('data len', dataRef._docs.length);
  //   await Promise.all(
  //     dataRef._docs.map(async (docEle, index) => {
  //       let cObj = docEle.data();
  //       if (cObj?.issuerAddress) {
  //         console.log('docEle.id', docEle.id);

  //         let ObjRef = doc(firebaseFireStore, 'musicartNfts', docEle.id);
  //         batch.update(ObjRef, {
  //           issuerAddress: null,
  //         });
  //       }

  // if (dataRef._docs.length - 1 === index) {
  //   lastDoc = docEle;
  // }
  //     }),
  //   );
  //   // await batch.commit();
  //   console.log('done');
  // };

  // const test = async () => {
  //   console.log('start');

  //   let dataRef = await getDocs(
  //     query(collection(firebaseFireStore, 'musicartArtists')),
  //   );

  //   let batch = writeBatch(firebaseFireStore);

  //   await Promise.all(
  //     dataRef._docs.map(async (docEle, key) => {
  //       //getting artists nfts
  //       let dataRef2 = await getDocs(
  //         query(
  //           collection(firebaseFireStore, 'musicartNfts'),
  //           where('adminState', '==', 'ACCEPT'),
  //           where('activeInMarketPlace', '==', true),
  //           where('artistId', '==', docEle.id),
  //         ),
  //       );

  //       let nftCount = 0;
  //       let nftCountPopularity = 0;

  //       await Promise.all(
  //         dataRef2._docs.map(async (doc2) => {
  //           nftCount = nftCount + 1;
  //           let cObj = doc2.data();

  //           if (cObj.isMultiple && Number(cObj.nftQuantity) > 1) {
  //             let startingPrice = 0;
  //             Object.values(cObj.multipleNftDetails)
  //               .filter((x) => x.activeInMarketPlace)
  //               .map((ele, index) => {
  //                 if (ele.adminState === 'ACCEPT' && ele.activeInMarketPlace) {
  //                   if (
  //                     ele.nftSaleType &&
  //                     ele.nftSaleType !== 'Auctioning' &&
  //                     ele.price &&
  //                     (!startingPrice ||
  //                       (startingPrice && Number(ele.price) < startingPrice))
  //                   ) {
  //                     startingPrice = Number(ele.price);
  //                   } else if (
  //                     ele.nftSaleType &&
  //                     ele.nftSaleType === 'Auctioning' &&
  //                     ele.auctionEndTime &&
  //                     ele.minBiddingPrice &&
  //                     (!startingPrice ||
  //                       (startingPrice &&
  //                         Number(ele.minBiddingPrice) < startingPrice))
  //                   ) {
  //                     startingPrice = Number(ele.minBiddingPrice);
  //                   }
  //                 }
  //               });
  //             if (startingPrice || cObj.preview) {
  //               nftCountPopularity = nftCountPopularity + 1;
  //             }
  //           } else {
  //             if (
  //               (cObj.nftSaleType &&
  //                 cObj.nftSaleType === 'Auctioning' &&
  //                 cObj.auctionEndTime &&
  //                 cObj.minBiddingPrice) ||
  //               (cObj.nftSaleType !== 'Auctioning' && cObj.price) ||
  //               cObj.preview
  //             ) {
  //               nftCountPopularity = nftCountPopularity + 1;
  //             }
  //           }
  //         }),
  //       );

  //       let artistRef = doc(firebaseFireStore, 'musicartArtists', docEle.id);
  //       batch.update(artistRef, { nftsCountLive: nftCountPopularity });

  //       console.log('artist id', docEle.id);
  //       console.log('nftCount', nftCount);
  //       console.log('nftCountPopularity', nftCountPopularity);
  //     }),
  //   );

  //   await batch.commit();
  // };

  //const test

  // const test = async () => {
  //   console.log('start');

  //   let q;

  //   if (lastDoc) {
  //     console.log('continue');
  //     q = query(
  //       collection(firebaseFireStore, 'musicartNfts'),
  //       where('isMultiple', '==', false),
  //       startAfter(lastDoc),
  //       limit(500),
  //     );
  //   } else {
  //     console.log('new');
  //     q = query(
  //       collection(firebaseFireStore, 'musicartNfts'),
  //       where('isMultiple', '==', false),
  //       limit(500),
  //     );
  //   }

  //   const querySnapshot = await getDocs(q);
  //   let batch = writeBatch(firebaseFireStore);

  //   querySnapshot.forEach((docEle, index) => {
  //     console.log(docEle.id, ' => ', docEle.data());
  //     let cobj = docEle.data();
  //     if (!cobj.usersId && cobj.userId) {
  // let dbRef = doc(firebaseFireStore, 'musicartNfts', docEle.id);
  // batch.update(dbRef, { usersId: [cobj.userId] });
  //     }

  //     if (querySnapshot._docs.length - 1 === index) {
  //       lastDoc = docEle;
  //     }
  //   });

  // await batch.commit();
  //   console.log('done');
  // };

  // const test = async () => {
  //   console.log('start');

  //   let testApi = httpsCallable(firebaseFunctions, 'test_hctransfer');

  //   let apiRes = await testApi({});
  //   console.log('apiRes', apiRes);
  // };

  // const test = async () => {
  //   let batch = writeBatch(firebaseFireStore);

  //   let dbRef = doc(
  //     firebaseFireStore,
  //     'pathStore',
  //     'Asku0Bxxc7ddohCQlymncuD81Dm1',
  //     'wallets',
  //     '00000000-0000-0000-0000-000000000000',
  //   );
  //   batch.set(dbRef, {
  //     address: [
  //       {
  //         address: '1BwGfTX4Z61WWoqsN8PX6avTwtj44ZAds3',
  //         path: "m/44'/0'/0'/0/0",
  //       },
  //       {
  //         address: '1AUFa5ZSsXiswMab5WkCu2G99zuNHRJRR2',
  //         path: "m/44'/0'/0'/0/1",
  //       },
  //       {
  //         address: '16FATGSs8cRRj6debwkAPHAiiKK9296oEg',
  //         path: "m/44'/0'/0'/0/2",
  //       },
  //       {
  //         address: '1AzDhkM1KVHEunYzcyan7WAWnW3HPcev8E',
  //         path: "m/44'/0'/0'/0/3",
  //       },
  //       {
  //         address: '131f13N1VRkF3MuqqQ7yvsWcssCQyschjo',
  //         path: "m/44'/0'/0'/0/4",
  //       },
  //       {
  //         address: '1KjPeGznSUtBqNCby1U6GABzzBaY2rR2dR',
  //         path: "m/44'/0'/0'/0/5",
  //       },
  //       {
  //         address: '13sP3NMsWFeUoXkQTEj8YHNdTiKFGiE3zw',
  //         path: "m/44'/0'/0'/0/6",
  //       },
  //       {
  //         address: '12kZh4LZMUjgWs3aQRemA2UYo4enUMqY9A',
  //         path: "m/44'/0'/0'/0/7",
  //       },
  //       {
  //         address: '1APjmu9iVgAcoA3Hb7m2UUYN7Rhpu5ir7Z',
  //         path: "m/44'/0'/0'/0/8",
  //       },
  //       {
  //         address: '13oRhyC1PPebokutdWL8KktCa3bLGoRmgP',
  //         path: "m/44'/0'/0'/0/9",
  //       },
  //       {
  //         address: '1TTcV29Ka24BJtD6TK23VJvBCNqJ36H32',
  //         path: "m/44'/0'/0'/0/10",
  //       },
  //       {
  //         address: '1FooRfJLhCZJN4ph9wDJrUkirpSaWTqjg3',
  //         path: "m/44'/0'/0'/0/11",
  //       },
  //       {
  //         address: '1GgLEiZJpw9pKiRgLMWZ6tAZk7UKU5QT1T',
  //         path: "m/44'/0'/0'/0/12",
  //       },
  //       {
  //         address: '13EfbKwPr7LRfFW1Svo2kxVVLxd81voodV',
  //         path: "m/44'/0'/0'/0/13",
  //       },
  //       {
  //         address: '1EPDbt4p3KcwbZnPz5j9UKFtHWWjphjHtg',
  //         path: "m/44'/0'/0'/0/14",
  //       },
  //       {
  //         address: '14X6MCvozB5UFuZb7np5z1WzsN7tnbSu2v',
  //         path: "m/44'/0'/0'/0/15",
  //       },
  //       {
  //         address: '141jrfbamnZ88FUtYr5nW2tBtmCUhyCRPn',
  //         path: "m/44'/0'/0'/0/16",
  //       },
  //       {
  //         address: '12UEoxs4UaAfZwtVZnLyMHzLTGsEpzAjVN',
  //         path: "m/44'/0'/0'/0/17",
  //       },
  //       {
  //         address: '17mVWyRDYyqcgXRCbFbttpzi6X4QkqfumU',
  //         path: "m/44'/0'/0'/0/18",
  //       },
  //       {
  //         address: '194zubmix4eQYSV4qxPEa8JmRNDmHwvRan',
  //         path: "m/44'/0'/0'/0/19",
  //       },
  //     ],
  //   });
  //   await batch.commit();
  // };
  return (
    <main className="main">
      {/* <button onClick={test}>test</button> */}

      {/* <AboutContainer /> */}
      <ImagesContainer />
      <TeamContainer />
      {/* <SampleNftsContainer /> */}
    </main>
  );
}
